import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/vertical-divider.svg'


const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "profile-sidebar"
}
const _hoisted_3 = { class: "experience-container" }
const _hoisted_4 = { class: "divider-text-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "image-divider-container" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_6 = { class: "text-container" }
const _hoisted_7 = { class: "default-text-header" }
const _hoisted_8 = { class: "experiences-wrapper" }
const _hoisted_9 = { class: "default-text-header text-experience" }
const _hoisted_10 = { class: "small-text text-experience" }
const _hoisted_11 = {
  key: 0,
  class: "wordcloud-container"
}
const _hoisted_12 = { class: "default-text-header" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "image-word" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "personal-info-container" }
const _hoisted_17 = { class: "user-avatar" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "text-profile-container" }
const _hoisted_20 = { class: "default-text-header profile-text-title" }
const _hoisted_21 = { class: "small-text-grey-10 user-role" }
const _hoisted_22 = { class: "small-text-grey-10 text-experience user-motto" }
const _hoisted_23 = { class: "hobbies-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hobbie = _resolveComponent("hobbie")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.openOverlay)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "overlay",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('togglenav')))
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "profile-sidebar-transition" }, {
      default: _withCtx(() => [
        (_ctx.openOverlay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("community-profile.experience")), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.experiences, (experience, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "experiences-container",
                          key: index
                        }, [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(experience.data), 1),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(experience.experience), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                (_ctx.user.wordcloud)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("community-profile.lately-worked-with")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("img", {
                          class: "wordcloud-image",
                          src: _ctx.getImg(_ctx.user.wordcloud)
                        }, null, 8, _hoisted_15)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    class: "avatar",
                    src: _ctx.getImg(_ctx.user.avatar)
                  }, null, 8, _hoisted_18)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.user.name), 1),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.user.role), 1),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.user.motto), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_hobbie, {
                    hobbies: _ctx.user.hobbies
                  }, null, 8, ["hobbies"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}